import "./services.css";

export default function Services() {
    const services = [
        {
            icon: "fas fa-laptop-code",
            title: "Web Development",
            description: "Building high-performance, scalable websites with modern frameworks and responsive design."
        },
        {
            icon: "fas fa-mobile-screen-button",
            title: "App Development",
            description: "Crafting intuitive iOS and Android applications that provide seamless user experiences."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "IT Training",
            description: "Professional coaching in full-stack technologies to bridge the gap between learning and industry."
        },
        {
            icon: "fas fa-cloud-arrow-up",
            title: "Cloud Solutions",
            description: "Deploying and managing secure cloud infrastructure to ensure your data is always accessible."
        },
        {
            icon: "fas fa-chart-line",
            title: "Digital Strategy",
            description: "Data-driven marketing and growth strategies to scale your business in the digital landscape."
        },
        {
            icon: "fas fa-shield-halved",
            title: "Cyber Security",
            description: "Protecting your digital assets with advanced security audits and proactive threat monitoring."
        }
    ];

    return (
        <section className="services-section py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <span className="badge rounded-pill bg-soft-primary px-3 py-2 mb-2">SOLUTIONS</span>
                    <h2 className="display-5 fw-bold mb-3">
                        Our Specialized <span className="text-gradient">Services</span>
                    </h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
                        We leverage cutting-edge technology to solve complex business challenges and drive digital transformation.
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div className="service-card" key={index}>
                            <div className="card-top">
                                <div className="icon-box">
                                    <i className={service.icon}></i>
                                </div>
                                <span className="service-number">0{index + 1}</span>
                            </div>
                            <div className="card-body">
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                            <div className="card-footer">
                                <button className="learn-more">
                                    Learn More <i className="fas fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}